import { ACCOUNT_LOGIN_REQUEST, ACCOUNT_LOAD, LOGOUT_ACCOUNT, UPDATE_PROFILE } from "../action.types"
import {appInsights} from "../../shared/services/AppInsightsService";

export const login = data => ({
  type: ACCOUNT_LOGIN_REQUEST,
  payload: {
    request: {
      method: 'post',
      url: `contas/acessar/usuario`,
      data
    }
  }
})

export const logOut = () => {
  localStorage.clear();
  appInsights.clearAuthenticatedUserContext()
  return {
    type: LOGOUT_ACCOUNT
  }
}

export const load = () => {
  const jsonProfile = localStorage.getItem(process.env.REACT_APP_PROFILE);
  const profile = jsonProfile ? JSON.parse(jsonProfile) : {};

  appInsights.setAuthenticatedUserContext(profile.id, profile.email, false)

  return {
    type: ACCOUNT_LOAD,
    account: profile
  }
}

export const updateProfile = profile => {
  return {
    type: UPDATE_PROFILE,
    account: profile
  }
}
